import {RootStore} from './RootStore';
import { observable, action, reaction } from 'mobx';
import agent from '../api/agent';
import { examParam, kelasParam, ObeParam,ClassListParam } from '../models/Obe';

class ObeStore{

    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    @action getExamTypeList = async (strm: string, class_nbr: number) => {
        try 
        {   
            const list = await agent.Obe.examList(strm,class_nbr);
            const result = list.result;
            let data = new Array();
            for (let res of result) {
                const label = {label: res.DESCR, value: res.SEQUENCE_NO};
                data.push(label);
            }
            return data;
        } catch (error) {
            throw error;
        }
    };

    @action getSeqNumList = async (strm: string, class_nbr: number) => {
        try 
        {   
            const list = await agent.Obe.examList(strm,class_nbr);
            const result = list.result;
            let data = new Array();
            for (let res of result) {
                const label = {id: res.DESCR, name: res.SEQUENCE_NO};
                data.push(label);
            }
            return data;
        } catch (error) {
            throw error;
        }
    };

    @action getExamTypeDesc = async (param:ObeParam) => {
        try 
        {   
            const list = await agent.Obe.examTypeDesc(param);
            return list.result;
        } catch (error) {
            throw error;
        }
    };


    @action getClassList = async (param:ClassListParam) => {
        try 
        {   
            const list = await agent.Obe.classList(param)
            return list.result
        } catch (error) {
            throw error;
        }
    };


    @action getObeGradeList = async (param:ObeParam) => {
        try 
        {   
            const list = await agent.Obe.gradeList(param);
            return list;
        } catch (error) {
            throw error;
        }
    };

    @action getObeColumnList = async (param:ObeParam) => {
        try
        {
            const list = await agent.Obe.columnList(param);
            return list.result;
        } catch (error) {
            throw error;
        }
    }

    @action getRecapTableList = async (strm: string, class_nbr: string, emplid:string) => {
        try
        {
            const list = await agent.Obe.recapTable(strm,class_nbr,emplid);
            return list.result;
        } catch (error) {
            throw error;
        }
    }

    @action getRecapTableCol = async (strm: string, class_nbr: string) => {
        try
        {
            const list = await agent.Obe.recapTableCol(strm,class_nbr);
            return list.result;
        } catch (error) {
            throw error;
        }
    }

    @action getChart100 = async (param : ObeParam) => {
        try
        {
            const list = await agent.Obe.chart100(param);
            const result = list.result;
            // let data = new Array();
            var array_return:any = {
                label:[],
                data:[]
            }
            for (let res of result) {
                array_return.label.push(res.LO_ID);
                array_return.data.push(res.AVG_PER_LO_PER_GRADING);
            }
            return array_return;
        } catch (error) {
            throw error;
        }
    }

    @action getChart4 = async (strm: string, class_nbr: string,emplid:string) => {
        try
        {
            const list = await agent.Obe.chart4(strm,class_nbr,emplid);
            const result = list.result;
            var array_return:any = {
                label:[],
                data:[]
            }
            for (let res of result) {
                array_return.label.push(res.LO_ID)
                array_return.data.push(res.AVG_PER_LO_4)
            }
            return array_return;
        } catch (error) {
            throw error;
        }
    }

    @action mergeGradeDetail = async (param:any) => {
        try 
        {   
            const list = await agent.Obe.mergeGradeDetail(param);
            return list;
        } catch (error) {
            throw error;
        }
    };

}

export default ObeStore